import { ShoppingBag } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Famous Fried Artichokes", id: "famous", testid: "nav-link-famous" },
  { label: "Menu", id: "menu", testid: "nav-link-menu" },
  { label: "Hours & Location", id: "visit", testid: "nav-link-visit" },
];

export default function Nav() {
  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mt-4 flex items-center justify-between rounded-full border border-leafline/70 bg-cream/80 py-2.5 pl-4 pr-2.5 shadow-lg shadow-artichoke/10 backdrop-blur-xl">
          <button
            data-testid="nav-brand"
            onClick={() => scrollToId("top")}
            className="flex items-center gap-2.5"
          >
            <img
              src="/logo.png"
              alt="Giant Artichoke Cafe & Grill logo"
              className="h-10 w-10 rounded-full shadow-md"
            />
            <span className="text-left font-display text-lg font-semibold leading-none text-deep">
              Giant Artichoke
              <span className="block text-[10px] font-medium tracking-[0.28em] text-grape">
                CAFE & GRILL
              </span>
            </span>
          </button>
          <nav className="hidden items-center gap-7 md:flex">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={l.testid}
                onClick={() => scrollToId(l.id)}
                className="text-sm font-semibold text-deep/70 transition-colors hover:text-grape"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <a
            data-testid="nav-order-now-button"
            href="/order"
            className="group inline-flex items-center gap-2 rounded-full bg-artichoke px-5 py-2.5 text-sm font-bold text-cream transition-all hover:scale-[1.04] hover:bg-deep active:scale-95"
          >
            <ShoppingBag className="h-4 w-4 transition-transform group-hover:-rotate-12" />
            Order Now
          </a>
        </div>
      </div>
    </header>
  );
}
